export type EventContext = Record<string, string>

export enum Flow {
  Auth = "Auth",
  Buy = "Buy",
  MultipleBuy = "Multiple buy",
  Listing = "Listing",
  CancelListing = "Cancel listing",
  AcceptOffer = "Accept offer",
  AcceptMultipleOffers = "Accept multiple offers",
  CancelOffer = "Cancel offer",
  MakeOffer = "Make offer",
  WhitelistCollection = "Whitelist collection",
  Mint = "Mint item",
  WithdrawBalance = "Withdraw balance",
  DepositBalance = "Deposit balance",
  TransferItem = "Transfer item",
  CrossmintSecondaryCheckout = "Crossmint secondary checkout",
  CoinflowSecondaryCheckout = "Coinflow secondary checkout",
  BrandPage = "Brand page",
  Swap = "Swap",
}
